import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 行情数据接口
enum API {
  // 行情涨跌分布数据
  MarketChgDistributionOverview = '/hk-web/market/chg-distribution/overview',
  // 查询币种支持的杠杆/合约/现货类型
  CurrencyTradeSupport = '/hk-web/currency/trade/support',
  // 查询币种支持买币/理财推荐
  CurrencyTradeRecommend = '/hk-web/currency/trade/recommend',
  // 全网风向标-合约爆仓数据
  MarketContractForceLiquidation = '/hk-web/market/contract/force-liquidation',
  // 全网风向标-资金费率数据
  MarketContractFundingRate = '/hk-web/market/contract/funding-rate',
  // 全网风向标-全网合约历史成交额
  MarketContractHistoryAmount = '/hk-web/market/contract/history-amount',
  // 全网风向标-全网合约持仓量数据
  MarketContractOpenInterest = '/hk-web/market/contract/open-interest',
  // 全网风向标-概览数据
  MarketContractOverviewVolume = '/hk-web/market/contract/overview-volume',
  // 全网风向标-现货概览数据
  MarketSpotOverviewVolume = '/hk-web/market/spot/overview-volume',
  // 全网风向标-现货大盘图表-总市值
  MarketSpotOverviewChartTotalMarketCap = '/hk-web/market/spot/overview-chart/total-market-cap',
  // 全网风向标-现货大盘图表-稳定币
  MarketSpotOverviewChartStable = '/hk-web/market/spot/overview-chart/stable',
  // 全网风向标-现货大盘图表-24小时交易量
  MarketSpotOverviewChartVolume = '/hk-web/market/spot/overview-chart/volume',
  // 全网风向标-现货大盘图表-BTC市值占比
  MarketSpotBtcDominance = '/hk-web/market/spot/btc-dominance',
  // 全网风向标-现货大盘图表-ETF机构列表
  MarketSpotOverviewChartEtfList = '/hk-web/market/spot/overview-chart/etf-list',
  // 全网风向标-现货大盘图表-ETF净流入流出
  MarketSpotOverviewChartEtfFlow = '/hk-web/market/spot/overview-chart/etf-flow',
  // 全网风向标-合约统计币种列表
  MarketContractCurrencies = '/hk-web/market/contract/currencies',
  // 查询主流交易对行情数据
  MarketRankingMainTrades = '/hk-web/market/ranking/main-trades',
  // 查询新币上线推荐
  MarketRecommendNewListings = '/hk-web/market/recommend/new-listings',
  // 查询新币榜行情数据
  MarketRankingNewListings = '/hk-web/market/ranking/new-listings',
  // 查询推荐交易对行情数据
  MarketRankingRecommends = '/hk-web/market/ranking/recommends',
  // 查询涨幅榜行情数据
  MarketRankingTopGainers = '/hk-web/market/ranking/top-gainers',
  // 现货主动买入卖出
  StatSpotTakerVolume = '/hk-web/stat/spot/taker-volume',
  // 查询跌幅榜行情数据
  MarketRankingTopLosers = '/hk-web/market/ranking/top-losers',
  // 查询成交额榜行情数据
  MarketRankingTurnOver = '/hk-web/market/ranking/turn-over',
  // 查询周热力榜行情数据
  MarketRankingWeekStar = '/hk-web/market/ranking/week-star',
  // 生态专区详情
  MarketZoneDetail = '/hk-web/market/zone/detail',
  // 合约多空人数比数据
  StatContractLsAccountRatio = '/hk-web/stat/contract/ls-account-ratio',
  // 合约持仓总量数据
  StatContractOpenInterestVolume = '/hk-web/stat/contract/open-interest-volume',
  // 合约主动买入卖出
  StatContractTakerVolume = '/hk-web/stat/contract/taker-volume',
  // 现货资金流向分析
  StatSpotFlowAnalysis = '/hk-web/stat/spot/flow-analysis',
  // 查询现货K线历史委托
  TradeSpotFetchKlineOrders = '/hk-web/trade/spot/fetch-kline-orders',
  // 生态专区列表
  MarketZoneList = '/hk-web/market/zone/list',
  // 交易数据统计币种列表
  MarketTradeStatCurrencies = '/hk-web/market/trade-stat/currencies',
  // 菜单生态专区列表
  FunctionsEcoZones = '/hk-web/functions/eco/zones',
  // 币种市值热力图
  MarketHeatmapListing = '/hk-web/market/heatmap/listing',
  // 查询热门榜行情数据
  MarketRankingHotListings = '/hk-web/market/ranking/hot-listings',
  // 查询24H涨跌走势图数据
  MarketTrendlines = '/kline-history/market/trendlines',
  // 查询板块币种列表
  MarketRegionCurrencies = '/hk-web/market/region-currencies',
  // 搜索热门推荐
  MarketSearchPopular = '/hk-web/market/search/popular',
  // 币对搜索结果
  MarketSearchResult = '/hk-web/market/search/result',
  // 行情多涨跌幅
  MarketMultiChange = '/hk-web/market/multi-change',
}

export type TGetMarketChgDistributionOverviewParams = any
export type TGetMarketChgDistributionOverviewResponse = TResponse<{
  downNum?: number // 下跌数量
  flatNum?: number // 持平数量
  list?: {
    chgType?: number
    name?: string
    num?: number
  }[]
  upNum?: number // 上涨数量
}>
export const getMarketChgDistributionOverview = (params?: TGetMarketChgDistributionOverviewParams) => {
  return hcAxios.get<TGetMarketChgDistributionOverviewResponse>(API.MarketChgDistributionOverview, { params })
}

export type TGetCurrencyTradeSupportParams = {
  currency?: any // 合约标的币名称，如BTC，大小写均可
  tradeId?: any // 现货交易对ID
}
export type TGetCurrencyTradeSupportResponse = TResponse<{
  baseCurrency?: string // 标的币名称，比如BTC
  contractCode?: string // 合约币对名称
  isFutureTrade?: boolean // 是否支持合约交易
  isMarginTrade?: boolean // 是否支持杠杆交易
  isResearchRecommend?: boolean // 是否支持严选
  isSpotTrade?: boolean // 是否支持现货交易
  quoteCurrency?: string // 计价币名称，比如USDT
  tradeId?: number // 现货币对id
}>
export const getCurrencyTradeSupport = (params?: TGetCurrencyTradeSupportParams) => {
  return hcAxios.get<TGetCurrencyTradeSupportResponse>(API.CurrencyTradeSupport, { params })
}

export type TGetCurrencyTradeRecommendParams = {
  coinId?: any // 币种ID
  currency?: any // 币种名称
}
export type TGetCurrencyTradeRecommendResponse = TResponse<{
  coinId?: number // 币种id
  isC2cTrade?: boolean // 是否支持C2C交易
  isCcbTrade?: boolean // 是否支持信用卡买币交易
  isEarnTrade?: boolean // 是否支持理财交易
  productId?: number // 产品id
  productType?: number // 产品类型 1活期， 2定期， 9质押借币
  profitRate?: string // 年化利率
}>
export const getCurrencyTradeRecommend = (params?: TGetCurrencyTradeRecommendParams) => {
  return hcAxios.get<TGetCurrencyTradeRecommendResponse>(API.CurrencyTradeRecommend, { params })
}

export type TGetMarketContractForceLiquidationParams = {
  coinId?: any // 币种id 不传查全部
  currency?: any // 币种名称
  limitSize?: any
  period?: any // 统计周期，5m/1h/1d
}
export type TGetMarketContractForceLiquidationResponse = TResponse<string[]>
export const getMarketContractForceLiquidation = (params?: TGetMarketContractForceLiquidationParams) => {
  return hcAxios.get<TGetMarketContractForceLiquidationResponse>(API.MarketContractForceLiquidation, { params })
}

export type TGetMarketContractFundingRateParams = any
export type TGetMarketContractFundingRateResponse = TResponse<
  {
    bitPrice?: string // 币种价格
    dateTime?: number // 时间戳
    fundingRateList?: {
      exchangeName?: string // 交易所名称
      fundingRate?: string // 币种价格
    }[] // 全网合约资金费率列表
  }[]
>
export const getMarketContractFundingRate = (params?: TGetMarketContractFundingRateParams) => {
  return hcAxios.get<TGetMarketContractFundingRateResponse>(API.MarketContractFundingRate, { params })
}

export type TGetMarketContractHistoryAmountParams = {
  coinId?: any // 币种id 不传查全部
  currency?: any // 币种名称
  limitSize?: any
}
export type TGetMarketContractHistoryAmountResponse = TResponse<string[]>
export const getMarketContractHistoryAmount = (params?: TGetMarketContractHistoryAmountParams) => {
  return hcAxios.get<TGetMarketContractHistoryAmountResponse>(API.MarketContractHistoryAmount, { params })
}

export type TGetMarketContractOpenInterestParams = {
  coinId?: any // 币种id
  currency?: any // 币种名称
  limitSize?: any
  period?: any // 统计周期，1m/5m/15m/30m/1h/2h/1d
}
export type TGetMarketContractOpenInterestResponse = TResponse<string[]>
export const getMarketContractOpenInterest = (params?: TGetMarketContractOpenInterestParams) => {
  return hcAxios.get<TGetMarketContractOpenInterestResponse>(API.MarketContractOpenInterest, { params })
}

export type TGetMarketContractOverviewVolumeParams = any
export type TGetMarketContractOverviewVolumeResponse = TResponse<{
  buyRatio?: string // BTC多方比
  forceLiquidation?: string // 24小时合约爆仓量
  forceLiquidationChange?: string // 24小时合约爆仓量涨跌幅
  histroyAmount?: string // 24小时全网合约成交量
  histroyAmountChange?: string // 24小时全网合约成交量涨跌幅
  lsAccountRatio?: string // BTC多空比
  openInterest?: string // 全网合约持仓量
  openInterestChange?: string // 全网合约持仓量涨跌幅
  openInterestLines?: string[] // 全网合约持仓量走势图
  sellRatio?: string // BTC空方比
}>
export const getMarketContractOverviewVolume = (params?: TGetMarketContractOverviewVolumeParams) => {
  return hcAxios.get<TGetMarketContractOverviewVolumeResponse>(API.MarketContractOverviewVolume, { params })
}

export type TGetMarketSpotOverviewVolumeParams = any
export type TGetMarketSpotOverviewVolumeResponse = TResponse<{
  btcEtfNetFlow?: number // BTC现货ETF净流入
  btcEtfNetFlowPercentage?: number // BTC现货ETF净流入百分比
  btcMarketCapPercentage?: number // BTC市值占比
  buyRatio?: number // BTC24小时多比
  fearGreedIndex?: number // 恐惧贪婪指数
  sellRatio?: number // BTC24小时空比
  stableMarketCap?: number // 稳定币总市值
  stableMarketCapPercentage?: number // 稳定币总市值涨跌百分比
  totalMarketCap?: number // 全球加密货币市值
  totalMarketCapPercentage?: number // 总市值百分比
  totalVolume?: number // 24总成交量
  totalVolumePercentage?: number // 24总成交量百分比
}>
export const getMarketSpotOverviewVolume = (params?: TGetMarketSpotOverviewVolumeParams) => {
  return hcAxios.get<TGetMarketSpotOverviewVolumeResponse>(API.MarketSpotOverviewVolume, { params })
}

export type TGetMarketSpotOverviewChartTotalMarketCapParams = {
  period?: any // 统计周期，1d/7d/1m/1y/all
}
export type TGetMarketSpotOverviewChartTotalMarketCapResponse = TResponse<
  {
    lastUpdated?: number // 更新时间
    totalMarketCap?: number // 总市值
  }[]
>
export const getMarketSpotOverviewChartTotalMarketCap = (params?: TGetMarketSpotOverviewChartTotalMarketCapParams) => {
  return hcAxios.get<TGetMarketSpotOverviewChartTotalMarketCapResponse>(API.MarketSpotOverviewChartTotalMarketCap, {
    params,
  })
}

export type TGetMarketSpotOverviewChartStableParams = {
  period?: any // 统计周期，1d/7d/1m/1y/all
}
export type TGetMarketSpotOverviewChartStableResponse = TResponse<
  {
    lastUpdated?: number // 更新时间
    totalMarketCap?: number // 稳定币市值
    totalMarketCapPercentage?: number // 稳定币市值百分比
  }[]
>
export const getMarketSpotOverviewChartStable = (params?: TGetMarketSpotOverviewChartStableParams) => {
  return hcAxios.get<TGetMarketSpotOverviewChartStableResponse>(API.MarketSpotOverviewChartStable, { params })
}

export type TGetMarketSpotOverviewChartVolumeParams = {
  period?: any // 统计周期，1d/7d/1m/1y/all
}
export type TGetMarketSpotOverviewChartVolumeResponse = TResponse<
  {
    lastUpdated?: number // 更新时间
    totalVolume?: number // 交易量
    totalVolumePercentage?: number // 涨跌百分比
  }[]
>
export const getMarketSpotOverviewChartVolume = (params?: TGetMarketSpotOverviewChartVolumeParams) => {
  return hcAxios.get<TGetMarketSpotOverviewChartVolumeResponse>(API.MarketSpotOverviewChartVolume, { params })
}

export type TGetMarketSpotBtcDominanceParams = {
  period?: any // 统计周期，1d/7d/1m/1y/all
}
export type TGetMarketSpotBtcDominanceResponse = TResponse<
  {
    lastUpdated?: number // 时间戳
    tokenInfo?: {
      lastUpdated?: number // 时间戳
      percentage?: number // 百分比
      period?: string // 统计周期
      symbol?: string // symbol
      totalMarketCap?: number // 全球加密货币市值
    }[] // 各代币信息
  }[]
>
export const getMarketSpotBtcDominance = (params?: TGetMarketSpotBtcDominanceParams) => {
  return hcAxios.get<TGetMarketSpotBtcDominanceResponse>(API.MarketSpotBtcDominance, { params })
}

export type TGetMarketSpotOverviewChartEtfListParams = {
  count?: any // 是否返回总记录数，默认true
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
}
export type TGetMarketSpotOverviewChartEtfListResponse = TResponse<
  {
    btcHolding?: number // btc累计持有量
    netFlow?: number // 24小时净流入
    netFlowAccumulation?: number // 累计净流入
    ticker?: string // 机构代码
  }[]
>
export const getMarketSpotOverviewChartEtfList = (params?: TGetMarketSpotOverviewChartEtfListParams) => {
  return hcAxios.get<TGetMarketSpotOverviewChartEtfListResponse>(API.MarketSpotOverviewChartEtfList, { params })
}

export type TGetMarketSpotOverviewChartEtfFlowParams = {
  period?: any // 统计周期，1d/7d/1m/1y/all
}
export type TGetMarketSpotOverviewChartEtfFlowResponse = TResponse<
  {
    aum?: number // 资产管理规模
    changeUsd?: number // 净流入/流出
    lastUpdated?: number // 更新时间
    marketCap?: number // 市值
    price?: number // BTC价格
    volumeUsd?: number // 成交额
  }[]
>
export const getMarketSpotOverviewChartEtfFlow = (params?: TGetMarketSpotOverviewChartEtfFlowParams) => {
  return hcAxios.get<TGetMarketSpotOverviewChartEtfFlowResponse>(API.MarketSpotOverviewChartEtfFlow, { params })
}

export type TGetMarketContractCurrenciesParams = any
export type TGetMarketContractCurrenciesResponse = TResponse<
  {
    coinId?: number // 币种id
    currency?: string // 币种名称
    logo?: string // 币种Logo
  }[]
>
export const getMarketContractCurrencies = (params?: TGetMarketContractCurrenciesParams) => {
  return hcAxios.get<TGetMarketContractCurrenciesResponse>(API.MarketContractCurrencies, { params })
}

export type TGetMarketRankingMainTradesParams = {
  heatmapType?: any // 热力图类型，1-市值占比 2-24小时交易量占比
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingMainTradesResponse = TResponse<
  {
    buyShortName?: string // 币种简称
    buySymbol?: string // 买方币种全称
    change?: string // 24小时涨跌幅
    cny?: string // 折合人民币价格最新价
    digit?: string // 保留小数点,eg:2#4
    imageUrl?: string // 币种图片地址
    last?: string // 最新价
    sellCoinFullNameEn?: string // 标的币全称(英文)
    sellCoinFullNameZh?: string // 标的币全称(中文)
    sellShortName?: string // 卖方币种简称
    sellSymbol?: string // 卖方币种全称
    totalAmount?: string // 成交额
    tradeId?: number // 交易id
    volume?: string // 成交量
  }[]
>
export const getMarketRankingMainTrades = (params?: TGetMarketRankingMainTradesParams) => {
  return hcAxios.get<TGetMarketRankingMainTradesResponse>(API.MarketRankingMainTrades, { params })
}

export type TGetMarketRecommendNewListingsParams = {
  limit?: any // 查询条数，默认10条
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRecommendNewListingsResponse = TResponse<
  {
    buyShortName?: string // 币种简称
    change?: string // 24小时涨跌幅
    cny?: string // 最新价折合人民币价格
    digit?: string // 保留小数点,eg:2#4
    imageUrl?: string // 币种图片地址
    isOpen?: string // 开盘状态 0未开盘,1已开盘
    last?: string // 最新价
    listingTime?: number // 上市时间戳
    sellShortName?: string // 卖方币种简称
    totalAmount?: string // 成交额
    tradeId?: number // 交易id
    volume?: string // 成交量
  }[]
>
export const getMarketRecommendNewListings = (params?: TGetMarketRecommendNewListingsParams) => {
  return hcAxios.get<TGetMarketRecommendNewListingsResponse>(API.MarketRecommendNewListings, { params })
}

export type TGetMarketRankingNewListingsParams = {
  limit?: any // 查询条数，默认10条
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingNewListingsResponse = TResponse<
  {
    buyShortName?: string // 币种简称
    change?: string // 24小时涨跌幅
    cny?: string // 最新价折合人民币价格
    digit?: string // 保留小数点,eg:2#4
    imageUrl?: string // 币种图片地址
    isOpen?: string // 开盘状态 0未开盘,1已开盘
    last?: string // 最新价
    listingTime?: number // 上市时间戳
    sellShortName?: string // 卖方币种简称
    totalAmount?: string // 成交额
    tradeId?: number // 交易id
    volume?: string // 成交量
  }[]
>
export const getMarketRankingNewListings = (params?: TGetMarketRankingNewListingsParams) => {
  return hcAxios.get<TGetMarketRankingNewListingsResponse>(API.MarketRankingNewListings, { params })
}

export type TGetMarketRankingRecommendsParams = {
  heatmapType?: any // 热力图类型，1-市值占比 2-24小时交易量占比
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingRecommendsResponse = TResponse<
  {
    buyShortName?: string // 币种简称
    buySymbol?: string // 买方币种全称
    change?: string // 24小时涨跌幅
    cny?: string // 折合人民币价格最新价
    digit?: string // 保留小数点,eg:2#4
    imageUrl?: string // 币种图片地址
    last?: string // 最新价
    sellCoinFullNameEn?: string // 标的币全称(英文)
    sellCoinFullNameZh?: string // 标的币全称(中文)
    sellShortName?: string // 卖方币种简称
    sellSymbol?: string // 卖方币种全称
    totalAmount?: string // 成交额
    tradeId?: number // 交易id
    volume?: string // 成交量
  }[]
>
export const getMarketRankingRecommends = (params?: TGetMarketRankingRecommendsParams) => {
  return hcAxios.get<TGetMarketRankingRecommendsResponse>(API.MarketRankingRecommends, { params })
}

export type TGetMarketRankingTopGainersParams = {
  limit?: any // 查询条数，默认10条
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingTopGainersResponse = TResponse<any[]>
export const getMarketRankingTopGainers = (params?: TGetMarketRankingTopGainersParams) => {
  return hcAxios.get<TGetMarketRankingTopGainersResponse>(API.MarketRankingTopGainers, { params })
}

export type TGetStatSpotTakerVolumeParams = {
  coinId?: any // 币种id
  endTime?: any
  period?: any // 统计周期，1m/5m/15m/1h/4h/1d
  startTime?: any
  timeList?: any
}
export type TGetStatSpotTakerVolumeResponse = TResponse<string[]>
export const getStatSpotTakerVolume = (params?: TGetStatSpotTakerVolumeParams) => {
  return hcAxios.get<TGetStatSpotTakerVolumeResponse>(API.StatSpotTakerVolume, { params })
}

export type TGetMarketRankingTopLosersParams = {
  limit?: any // 查询条数，默认10条
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingTopLosersResponse = TResponse<any[]>
export const getMarketRankingTopLosers = (params?: TGetMarketRankingTopLosersParams) => {
  return hcAxios.get<TGetMarketRankingTopLosersResponse>(API.MarketRankingTopLosers, { params })
}

export type TGetMarketRankingTurnOverParams = {
  limit?: any // 查询条数，默认10条
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingTurnOverResponse = TResponse<
  {
    buyShortName?: string // 币种简称
    buySymbol?: string // 买方币种全称
    change?: string // 24小时涨跌幅
    cny?: string // 折合人民币价格最新价
    digit?: string // 保留小数点,eg:2#4
    imageUrl?: string // 币种图片地址
    last?: string // 最新价
    sellCoinFullNameEn?: string // 标的币全称(英文)
    sellCoinFullNameZh?: string // 标的币全称(中文)
    sellShortName?: string // 卖方币种简称
    sellSymbol?: string // 卖方币种全称
    totalAmount?: string // 成交额
    tradeId?: number // 交易id
    volume?: string // 成交量
  }[]
>
export const getMarketRankingTurnOver = (params?: TGetMarketRankingTurnOverParams) => {
  return hcAxios.get<TGetMarketRankingTurnOverResponse>(API.MarketRankingTurnOver, { params })
}

export type TGetMarketRankingWeekStarParams = {
  limit?: any // 查询条数，默认10条
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingWeekStarResponse = TResponse<
  {
    buyShortName?: string // 币种简称
    buySymbol?: string // 买方币种全称
    change?: string // 涨跌幅
    cny?: string // 折合人民币
    digit?: string // 保留小数点,eg:2#4
    imageUrl?: string // 币种图片地址
    last?: string // 最新价
    sellShortName?: string // 卖方币种简称
    sellSymbol?: string // 卖方币种全称
    tradeId?: number // 交易id
    volume?: string // 24小时标的币成交量
  }[]
>
export const getMarketRankingWeekStar = (params?: TGetMarketRankingWeekStarParams) => {
  return hcAxios.get<TGetMarketRankingWeekStarResponse>(API.MarketRankingWeekStar, { params })
}

export type TGetMarketZoneDetailParams = {
  code?: any // 专区id 1DeFi专区 2NFT板块 3波卡生态板块 4存储板块 5Layer2专区
  count?: any // 是否返回总记录数，默认true
  lang?: any // 语言
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  theme?: any // 主题：浅-light 深-dark
}
export type TGetMarketZoneDetailResponse = TResponse<{
  bgUrl?: string // 背景图片
  code?: number // 专区code
  iconUrl?: string // icon图片
  id?: number // 专区id
  introduction?: string // 专区介绍
  name?: string // 专区名称
}>
export const getMarketZoneDetail = (params?: TGetMarketZoneDetailParams) => {
  return hcAxios.get<TGetMarketZoneDetailResponse>(API.MarketZoneDetail, { params })
}

export type TGetStatContractLsAccountRatioParams = {
  buyTakerVolume?: any
  coinId?: any // 币种id
  currency?: any // 币种名称
  period?: any // 统计周期，5m/1h/1d
  sellTakerVolume?: any
}
export type TGetStatContractLsAccountRatioResponse = TResponse<string[]>
export const getStatContractLsAccountRatio = (params?: TGetStatContractLsAccountRatioParams) => {
  return hcAxios.get<TGetStatContractLsAccountRatioResponse>(API.StatContractLsAccountRatio, { params })
}

export type TGetStatContractOpenInterestVolumeParams = {
  buyTakerVolume?: any
  coinId?: any // 币种id
  currency?: any // 币种名称
  period?: any // 统计周期，5m/1h/1d
  sellTakerVolume?: any
}
export type TGetStatContractOpenInterestVolumeResponse = TResponse<string[]>
export const getStatContractOpenInterestVolume = (params?: TGetStatContractOpenInterestVolumeParams) => {
  return hcAxios.get<TGetStatContractOpenInterestVolumeResponse>(API.StatContractOpenInterestVolume, { params })
}

export type TGetStatContractTakerVolumeParams = {
  buyTakerVolume?: any
  coinId?: any // 币种id
  currency?: any // 币种名称
  period?: any // 统计周期，5m/1h/1d
  sellTakerVolume?: any
}
export type TGetStatContractTakerVolumeResponse = TResponse<string[]>
export const getStatContractTakerVolume = (params?: TGetStatContractTakerVolumeParams) => {
  return hcAxios.get<TGetStatContractTakerVolumeResponse>(API.StatContractTakerVolume, { params })
}

export type TGetStatSpotFlowAnalysisParams = {
  coinId?: any // 币种id
  endTime?: any
  period?: any // 统计周期，1m/5m/15m/1h/4h/1d
  startTime?: any
  timeList?: any
}
export type TGetStatSpotFlowAnalysisResponse = TResponse<{
  largeBuys?: string // 大单买入
  largeBuysRate?: string // 大单买入比例
  largeInflow?: string // 大单净流入
  largeSells?: string // 大单卖出
  largeSellsRate?: string // 大单卖出比例
  mediumBuys?: string // 中单买入
  mediumBuysRate?: string // 中单买入比例
  mediumInflow?: string // 中单净流入
  mediumSells?: string // 中单卖出
  mediumSellsRate?: string // 中单卖出比例
  smallBuys?: string // 小单买入
  smallBuysRate?: string // 小单买入比例
  smallInflow?: string // 小单净流入
  smallSells?: string // 小单卖出
  smallSellsRate?: string // 小单卖出比例
  sumBuys?: string // 汇总买入
  sumInflow?: string // 汇总净流入
  sumSells?: string // 汇总卖出
}>
export const getStatSpotFlowAnalysis = (params?: TGetStatSpotFlowAnalysisParams) => {
  return hcAxios.get<TGetStatSpotFlowAnalysisResponse>(API.StatSpotFlowAnalysis, { params })
}

export type TGetTradeSpotFetchKlineOrdersParams = {
  endTime?: any // 结束时间戳 13位,精确到毫秒
  limit?: any // 查询记录数，当startTime为空时，后端根据limit计算startTime
  marginMode?: any // 杠杆模式 nonmag非杠杆，margin杠杆
  period?: any // 粒度:1m,5m,15m,30m,1h,2h,4h,6h,12h,1d,3d,5d,1w,1mo，同K线一致
  startTime?: any // 开始时间戳 13位,精确到毫秒
  tradeId?: any // 交易对id
}
export type TGetTradeSpotFetchKlineOrdersResponse = TResponse<string[]>
export const getTradeSpotFetchKlineOrders = (params?: TGetTradeSpotFetchKlineOrdersParams) => {
  return hcAxios.get<TGetTradeSpotFetchKlineOrdersResponse>(API.TradeSpotFetchKlineOrders, { params })
}

export type TGetMarketZoneListParams = {
  size?: any // size
  timeZone?: any // timeZone
}
export type TGetMarketZoneListResponse = TResponse<
  {
    code?: number // 专区code
    id?: number // 专区id
    name?: string // 专区名称
    sortId?: number // 排序id
    topCoinId?: number // 币种id
    topCurrency?: string // 币种名称
    topCurrencyLogo?: string // 币种Logo
    topTradeId?: number // USDT交易区交易对id
    topchange?: string // 涨跌幅
  }[]
>
export const getMarketZoneList = (params?: TGetMarketZoneListParams) => {
  return hcAxios.get<TGetMarketZoneListResponse>(API.MarketZoneList, { params })
}

export type TGetMarketTradeStatCurrenciesParams = any
export type TGetMarketTradeStatCurrenciesResponse = TResponse<
  {
    coinId?: number // 币种id
    currency?: string // 币种名称
    logo?: string // 币种Logo
  }[]
>
export const getMarketTradeStatCurrencies = (params?: TGetMarketTradeStatCurrenciesParams) => {
  return hcAxios.get<TGetMarketTradeStatCurrenciesResponse>(API.MarketTradeStatCurrencies, { params })
}

export type TGetFunctionsEcoZonesParams = {
  count?: any // 是否返回总记录数，默认true
  lang?: any // 语言
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  theme?: any // 主题：浅-light 深-dark
}
export type TGetFunctionsEcoZonesResponse = TResponse<
  {
    bizCode?: number // 业务code，比如生态专区code
    code?: number // 菜单code
    iconUrl?: string // icon图片
    name?: string // 专区名称
  }[]
>
export const getFunctionsEcoZones = (params?: TGetFunctionsEcoZonesParams) => {
  return hcAxios.get<TGetFunctionsEcoZonesResponse>(API.FunctionsEcoZones, { params })
}

export type TGetMarketHeatmapListingParams = {
  heatmapType?: any // 热力图类型，1-市值占比 2-24小时交易量占比
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketHeatmapListingResponse = TResponse<
  {
    chg?: string // 涨跌幅
    coinId?: number // 币种ID
    coinName?: string // 币种名称
    currencyLogo?: string // 币种Log
    dominance?: number // 市值占比/24小时交易量占比，比如25.3656
    marketCap?: number // 市值USD
    tradeId?: number // 币种USDT交易区交易对ID
    usdPrice?: string // 币种转换为USD价格
    volume24h?: number // 24小时成交量USD
  }[]
>
export const getMarketHeatmapListing = (params?: TGetMarketHeatmapListingParams) => {
  return hcAxios.get<TGetMarketHeatmapListingResponse>(API.MarketHeatmapListing, { params })
}

export type TGetMarketRankingHotListingsParams = {
  limit?: any // 查询条数，默认10条
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketRankingHotListingsResponse = TResponse<
  {
    buyShortName?: string // 币种简称
    buySymbol?: string // 买方币种全称
    change?: string // 24小时涨跌幅
    cny?: string // 折合人民币最新价
    digit?: string // 保留小数点,eg:2#4
    imageUrl?: string // 币种图片地址
    last?: string // 最新价
    sellCoinFullNameEn?: string // 标的币全称(英文)
    sellCoinFullNameZh?: string // 标的币全称(中文)
    sellShortName?: string // 卖方币种简称
    sellSymbol?: string // 卖方币种全称
    totalAmount?: string // 成交额
    tradeId?: number // 交易id
    volume?: string // 成交量
  }[]
>
export const getMarketRankingHotListings = (params?: TGetMarketRankingHotListingsParams) => {
  return hcAxios.get<TGetMarketRankingHotListingsResponse>(API.MarketRankingHotListings, { params })
}

export type TGetMarketTrendlinesParams = {
  period?: any // 时间周期 :1h
  tradeIds?: any // 交易对id列表
}
export type TGetMarketTrendlinesResponse = TResponse<string[]>
export const getMarketTrendlines = (params?: TGetMarketTrendlinesParams) => {
  return hcAxios.get<TGetMarketTrendlinesResponse>(API.MarketTrendlines, { params })
}

export type TGetMarketRegionCurrenciesParams = {
  instTypeCode?: any // instTypeCode
}
export type TGetMarketRegionCurrenciesResponse = TResponse<
  {
    code?: number // 板块id 1-DeFi专区 2-NFT专区 3-波卡生态板块 4-存储板块 5-Layer2专区 6-元宇宙专区 7-AI专区 8-香港板块 9-COSMOS板块 10-Arbitrum 11-Meme 12-粉丝代币
    currencies?: {
      buyShortName?: string // 标的币
      coinId?: number // 币种id
      contractCode?: string // 合约交易对
      deliverContractCode?: string // 交割合约交易对
      sellShortName?: string // 计价币
      tradeId?: number // 现货交易对id
    }[] // 板块专区交易对
    name?: string // 板块简称
  }[]
>
export const getMarketRegionCurrencies = (params?: TGetMarketRegionCurrenciesParams) => {
  return hcAxios.get<TGetMarketRegionCurrenciesResponse>(API.MarketRegionCurrencies, { params })
}

export type TGetMarketSearchPopularParams = {
  heatmapType?: any // 热力图类型，1-市值占比 2-24小时交易量占比
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TGetMarketSearchPopularResponse = TResponse<
  {
    baseCurrency?: string // 标的币名称，比如BTC
    change?: string // 24小时涨跌幅
    contractCode?: string // 合约币对名称
    contractType?: string // 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季
    instType?: number // 产品类型，2-现货 3-杠杆 4-永续合约 5-交割合约 6-期权
    isMarginTrade?: boolean // 是否支持杠杆，true-是 false-否
    last?: string // 最新价
    liquidationDate?: number // 交割日期时间戳
    marginRatio?: string // 最大杠杆倍数
    quoteCurrency?: string // 计价币名称，比如USDT
    tradeId?: number // 现货币对id
    webLogo?: string // 币种Logo
  }[]
>
export const getMarketSearchPopular = (params?: TGetMarketSearchPopularParams) => {
  return hcAxios.get<TGetMarketSearchPopularResponse>(API.MarketSearchPopular, { params })
}

export type TPostMarketSearchResultParams = {
  keyword?: string // 搜索关键词
  timeZone?: number // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
}
export type TPostMarketSearchResultResponse = TResponse<{
  popular?: {
    baseCurrency?: string // 标的币名称，比如BTC
    change?: string // 24小时涨跌幅
    contractCode?: string // 合约币对名称
    contractType?: string // 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季
    instType?: number // 产品类型，2-现货 3-杠杆 4-永续合约 5-交割合约 6-期权
    isMarginTrade?: boolean // 是否支持杠杆，true-是 false-否
    last?: string // 最新价
    liquidationDate?: number // 交割日期时间戳
    marginRatio?: string // 最大杠杆倍数
    quoteCurrency?: string // 计价币名称，比如USDT
    tradeId?: number // 现货币对id
    webLogo?: string // 币种Logo
  }[] // 推荐币对列表
  result?: boolean // 是否存在搜索结果 true-是 false-否
  spots?: {
    baseCurrency?: string // 标的币名称，比如BTC
    change?: string // 24小时涨跌幅
    contractCode?: string // 合约币对名称
    contractType?: string // 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季
    instType?: number // 产品类型，2-现货 3-杠杆 4-永续合约 5-交割合约 6-期权
    isMarginTrade?: boolean // 是否支持杠杆，true-是 false-否
    last?: string // 最新价
    liquidationDate?: number // 交割日期时间戳
    marginRatio?: string // 最大杠杆倍数
    quoteCurrency?: string // 计价币名称，比如USDT
    tradeId?: number // 现货币对id
    webLogo?: string // 币种Logo
  }[] // 现货币对列表
  swaps?: {
    baseCurrency?: string // 标的币名称，比如BTC
    change?: string // 24小时涨跌幅
    contractCode?: string // 合约币对名称
    contractType?: string // 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季
    instType?: number // 产品类型，2-现货 3-杠杆 4-永续合约 5-交割合约 6-期权
    isMarginTrade?: boolean // 是否支持杠杆，true-是 false-否
    last?: string // 最新价
    liquidationDate?: number // 交割日期时间戳
    marginRatio?: string // 最大杠杆倍数
    quoteCurrency?: string // 计价币名称，比如USDT
    tradeId?: number // 现货币对id
    webLogo?: string // 币种Logo
  }[] // 合约币对列表
}>
export const postMarketSearchResult = (params?: TPostMarketSearchResultParams) => {
  return hcAxios.post<TPostMarketSearchResultResponse>(API.MarketSearchResult, params)
}

export type TGetMarketMultiChangeParams = {
  timeZone?: any // UTC时区，取值范围是 [-11,12] 的整数，如 8表示UTC+8(东8区)，北京时间
  tradeId?: any // 交易对ID
}
export type TGetMarketMultiChangeResponse = TResponse<{
  change180d?: string // 180天涨跌幅
  change1year?: string // 1年涨跌幅
  change30d?: string // 30天涨跌幅
  change7d?: string // 7天涨跌幅
  change90d?: string // 90天涨跌幅
  changeToday?: string // 今日涨跌幅
  tradeId?: number // 交易对ID
}>
export const getMarketMultiChange = (params?: TGetMarketMultiChangeParams) => {
  return hcAxios.get<TGetMarketMultiChangeResponse>(API.MarketMultiChange, { params })
}
